export default "__VITE_ASSET__DG8IbYvJ__"